export default __webpack_public_path__ + "static/media/vire8.3d8a4881.jpg";